(function () {
  const form = document.querySelector('[data-sort-form]');
  if (!form) return;
  const select = form.querySelector('[data-sort-select]');
  if (!select) return;
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
